const NotFound = () => {
    return (
        <div className="not-found">
            <h1 className="error-code">404</h1>
            <h1>This page is not found.</h1>
            <a href="/">Back to Homepage</a>
        </div>
    );
};

export default NotFound;
